<div fxFlex fxLayout="column" class="white-bg w-100-p" (click)="Actions.Close()">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="upload-status w-100-p">
        <div fxFlex fxLayout="column">
            <p class="unselectable ml-16 font-weight-700" *ngIf="!State.Completed">{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_UPLOADING'|translate}}</p>
            <p class="unselectable ml-16 font-weight-700" *ngIf="UploadQueue.length==1 && State.Completed">
                {{UploadQueue.length}} {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_UPLOAD_COMPLETE_MSG'|translate}}</p>
            <p class="unselectable ml-16 font-weight-700" *ngIf="UploadQueue.length>1 && State.Completed">
                    {{UploadQueue.length}} {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_UPLOADS_COMPLETE_MSG'|translate }}</p>
        </div>
        <div class="mr-4">
            <button mat-icon-button (click)="Actions.Close()">
                <mat-icon class="unselectable">close</mat-icon>
            </button>
        </div>
    </div>
    <mat-list class="queue-list w-100-p">
        <mat-list-item *ngFor="let queue of $UploadQueueSteam | async">
            <div style="padding: 0 0 0 16px; margin-right: -16px; margin-top: 16px;">
                <mat-icon *ngIf="queue.Percentage === 100" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="queue.Percentage === -1" color="warn">cancel</mat-icon>
            </div>
            <h4 mat-line>{{(queue?.Name.length>24)? (queue?.Name | slice:0:24)+'..':(queue?.Name)}}</h4>
            <h4 mat-line>
                <span *ngIf="queue.Percentage === -1">{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_ERROR_UPLOADING_FILE'|translate}}</span>
                <mat-progress-bar
                    *ngIf="queue.Percentage <= 100 && queue.Percentage >= 0"
                    [color]="'primary'"
                    [mode]="'determinate'"
                    [value]="queue.Percentage">
                </mat-progress-bar>
            </h4>
        </mat-list-item>
    </mat-list>
</div>
